import { useState, useRef, useEffect } from "react";
import BathtubIcon from "@mui/icons-material/Bathtub";

const AmenitiesToggle = ({ amenities = [] }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const hasAmenities = Array.isArray(amenities) && amenities.length > 0;

  // Close on outside click only
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative inline-flex items-center"
    >
      {/* Trigger */}
      <button
        type="button"
        disabled={!hasAmenities}
        onClick={() => hasAmenities && setOpen((v) => !v)}
        className={`flex items-center gap-2 text-sm font-medium ${
          hasAmenities
            ? "text-gray-700 hover:text-gray-900"
            : "text-gray-400 cursor-not-allowed"
        } focus:outline-none`}
      >
        {hasAmenities && <BathtubIcon color="info" />}
      </button>

      {/* Right-side Popover */}
      {open && hasAmenities && (
        <div className="absolute left-full ml-3 top-1/2 -translate-y-1/2 w-64 bg-white rounded-lg shadow-xl border z-50">
          <div className="px-4 py-2 text-sm font-semibold border-b text-gray-700 bg-white">
            Amenities
          </div>

          {/* Overflow handled here */}
          <ul className="px-4 py-3 space-y-1 text-sm text-gray-600 max-h-[30vh] overflow-y-auto">
            {amenities.map((item, index) => (
              <li key={index} className="capitalize">
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AmenitiesToggle;
